"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const react_redux_1 = require("react-redux");
const helper_1 = require("../../../../reviews/helper");
const sliceTemplate_1 = require("../../../slice/sliceTemplate");
const constants_1 = require("../../../slice/sliceTemplate/constants");
const store_1 = require("../../../store");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const PermissionSelects_1 = __importDefault(require("./PermissionSelects"));
const sliceReview_1 = require("../../../slice/sliceReview");
const selectors_1 = __importDefault(require("../../../slice/selectors"));
const TemplateSettingsModal = () => {
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const { templateName, isValidTemplateName, usersView, usersEdit, selectedTemplate, allowNext, } = (0, react_redux_1.useSelector)(selectors_1.default);
    (0, react_1.useEffect)(() => {
        if (selectedTemplate) {
            // edit a template
            dispatch((0, sliceTemplate_1.getPermissionTemplate)(selectedTemplate.value));
        }
        else {
            // create a new template
            const currentUser = {
                value: helper_1.USER.id,
                label: helper_1.USER.name,
            };
            // add current user into user permissions
            if (!usersEdit.some((user) => user.value === currentUser.value)) {
                dispatch((0, sliceTemplate_1.updatePermission)({
                    permissionType: constants_1.PERMISSION_TYPE.userEdit,
                    value: [...usersEdit, currentUser],
                }));
            }
            if (!usersView.some((user) => user.value === currentUser.value)) {
                dispatch((0, sliceTemplate_1.updatePermission)({
                    permissionType: constants_1.PERMISSION_TYPE.userView,
                    value: [...usersView, currentUser],
                }));
            }
            dispatch((0, sliceReview_1.disableNextBtn)());
        }
    }, [selectedTemplate]);
    const handleChangeTemplateName = (e) => {
        if (e.target.value !== '' && !allowNext) {
            dispatch((0, sliceReview_1.enableNextBtn)());
        }
        if (e.target.value === '' && allowNext) {
            dispatch((0, sliceReview_1.disableNextBtn)());
        }
        dispatch((0, sliceTemplate_1.updateTemplateName)(e.target.value));
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['template-settings-modal'] },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['template-settings-modal__name'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['template-settings-modal__name-root'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['template-name__container'] },
                    react_1.default.createElement("label", { className: styles_modules_less_1.default['template-name__label'] }, "Template name"),
                    react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                            content: "Give your template a name that describe it's purpose",
                            placement: 'top',
                            popperOptions: {
                                strategy: 'fixed',
                            },
                        } },
                        react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['template-name__icon'], 'fal fa-info-circle') }))),
                react_1.default.createElement("span", { className: isValidTemplateName
                        ? styles_modules_less_1.default['template-title__required--valid']
                        : styles_modules_less_1.default['template-title__required--invalid'] }, "*Required")),
            react_1.default.createElement(pulse_components_1.PulseInput, { InputBaseProps: {
                    classes: {
                        input: isValidTemplateName
                            ? styles_modules_less_1.default['template-title__input--valid']
                            : styles_modules_less_1.default['template-title__input--invalid'],
                    },
                    value: templateName,
                    placeholder: 'Enter a name for this round template',
                    onChange: handleChangeTemplateName,
                } })),
        react_1.default.createElement(material_1.Divider, null),
        react_1.default.createElement(PermissionSelects_1.default, null)));
};
exports.default = TemplateSettingsModal;
